/* eslint-disable */
import * as moment from 'moment';
import { fallback, yesNo, yesNoBlank, yn, ynb, existsOrBlank, conditionOrBlank } from './mapping-tools';
import { stripPhone, cleanDate } from './formatting';
import getAgentID from './getAgentID';

export default ({
  agent,
  quote,
  fields: res,
  plan,
  theme,
  confirmationNumber: confirmation,
}) => {

  const useCarrierPerms = theme.useCarrierPerms;

  let agentID;
  if (useCarrierPerms) {
    agentID = getAgentID({ agent, quote }).agentID;
  } else {
    agentID = agent.npn;
  }

  const isSEP = res.enrolltype === 'SEP';
  console.log('plan: ', plan);
  const isCSNP = plan.SNPIND === 1; // 1 = CSNP, 2 = DSNP, 3 = ISNP

  const premiumDeducted = {
    'rrb': 'Yes',
    'ssi': 'Yes',
    'cb': 'No',
    'eft': 'EFT',
  }[res.paymeth] || '';
  const premiumWithold = ['rrb', 'ssi'].includes(res.paymeth) ? res.paymeth.toUpperCase() : '';

  const planYear = plan.PlanYear;
  const isEFT = res.paymeth === 'eft';
  const eftActType = (res.eft_acttype === 'checking') ? 'Checking' : 'Savings';
  const effectiveDate = moment(res.effective_date).format('MMDDYYYY');
  const ltcfAddress = res.ltcf
    ? `${res.ltcf_addr_street1}${res.ltcf_addr_street2 ? ` ${res.ltcf_addr_street2}` : ''}, ${res.ltcf_addr_city}, ${res.ltcf_addr_state} ${res.ltcf_addr_zip}`
    : '';
  const creditableCoverage = typeof res.creditablecov === 'boolean' ? yn(res.creditablecov) : '';

  const affinityIDMap = theme.aetnaAffinityIDMap || {
    'ma': 'MyMedAgency_net',
    'mapd': 'MyMedAgency_net',
    'pdp': 'MyMedAgency_net',
  };
  const planType = plan.PlanTypeDesc.toLowerCase();
  const affinityID = affinityIDMap[planType];

  const sepMap = {
    ACC: 'S',
    CHR: 'S',
    NEW: 'E',
    ICE: 'I',
    RET: 'S',
    MRD: 'F',
    MOV: 'V',
    RUS: 'V',
    INC: 'S',
    LAW: 'S',
    LT2: 'T',
    LTC: (planType === 'pdp') ? 'S' : 'T',
    LEC: 'W',
    LCC: 'S',
    EOC: 'S',
    MYT: 'S',
    NON: 'S',
    PAC: 'S',
    SNP: 'S',
    MDE: 'L',
    MCD: 'U',
    NLS: 'U',
    LIS: 'U',
    DIF: 'U',
    PAP: 'S',
    '12G': 'S',
    DST: 'S',
    '12J': 'S',
    '5ST': 'R',
    LPI: 'S',
    REC: 'S',
    OTH: 'S',
    IEP: 'E',
    ICEP: 'I',
    OEP: (planType === 'mapd' || planType === 'ma') ? 'M' : 'S',
    // 'OEP-N': (planType === 'mapd' || planType === 'ma') ? 'M' : 'S',
    // 'OEP-I': planType === 'pdp' ? 'S' : 'T',
  };
  // Not in aetna docs, mapping election period to SEP map to use:
  // IEP = NEW
  // ICEP = ICE
  // OEP-I = LTC/LT2
  // OEP-N = OEP
  const electionPeriodMap = {
    'AEP': 'A',
    'SEP': sepMap[res.sep_code],
  };
  const electionType = electionPeriodMap[res.enrolltype];
  const sepDate = res.sep_date ? moment(res.sep_date).format('MMDDYYYY') : '';

  let race = '';
  let ethnicity = '';

  if (Array.isArray(res.race) && res.race.length) {
    race = res.race.join(',');
  }
  if (Array.isArray(res.ethnicity) && res.ethnicity.length) {
    ethnicity = res.ethnicity.join(',');
  }

  let appMethod = 'T' // Electronic
  // if (res.meetType === 'inPerson') appMethod = 'T'; // Telephonic
  // if (res.meetType === 'threeWayCall') appMethod = 'T'; // Telephonic

  let csnpCondition = '';
  if (Array.isArray(res.snp_conditions) && res.snp_conditions.length) csnpCondition = res.snp_conditions.join(',');
  const poaAddressConcat = res.ispoa ? `${res.poa_addr_street1} ${res.poa_addr_street2 || ''}`.trim() : ''
  const poaNameConcat = res.ispoa ? `${res.poa_fname} ${res.poa_lname}` : '';

  console.log('isCSNP: ', isCSNP);

  const formattedData = [
    { id: '01', col: 'ConfirmationNumber', val: confirmation },
    { id: '02', col: 'SignatureDate', val: moment().format('MMDDYYYY') },
    { id: '03', col: 'ContractID', val: plan.ExternalContractID },
    { id: '04', col: 'PlanID', val: plan.ExternalPlanID },
    { id: '05', col: 'SOA', val: yn(res.ack_soa) },
    { id: '06', col: 'ApplicantTitle', val: '' },
    { id: '07', col: 'ApplicantFirstName', val: res.first_name },
    { id: '08', col: 'ApplicantMiddleInitial', val: res.middle_name },
    { id: '09', col: 'ApplicantLastName', val: res.last_name },
    { id: '10', col: 'ApplicantBirthDate', val: moment(res.birthdate).format('MMDDYYYY') },
    { id: '11', col: 'ApplicantGender', val: res.gender },
    { id: '12', col: 'ApplicantAddress1', val: res.street1 },
    { id: '13', col: 'ApplicantAddress2', val: res.street2 },
    { id: '14', col: 'RequestedCounty', val: res.county_name },
    { id: '15', col: 'ApplicantCity', val: (res.city || '').slice(0, 30) },
    { id: '16', col: 'ApplicantState', val: res.state.toUpperCase() },
    { id: '17', col: 'ApplicantZip', val: res.zipcode},
    { id: '18', col: 'ApplicantPhone', val: stripPhone(res.home_phone) },
    { id: '19', col: 'ApplicantEmailAddress', val: res.email },
    { id: '20', col: 'MedicareNumber', val: res.medicare_id },
    { id: '21', col: 'ApplicationSSN', val: ''}, // Aetna spec says 'Should never be valued'
    { id: '22', col: 'MailingAddress1', val: res.samemail ? res.street1 : res.mailstreet1 },
    { id: '23', col: 'MailingAddress2', val: res.samemail ? res.street2 : res.mailstreet2 },
    { id: '24', col: 'ExistingPatientIndicator', val: res.pcp_name ? yn(res.pcp_established) : '' },
    { id: '25', col: 'MailingCity', val: res.samemail ? res.city : res.mailcity },
    { id: '26', col: 'MailingState', val: res.samemail ? res.state : res.mailstate },
    { id: '27', col: 'MailingZip', val: res.samemail ? res.zipcode : res.mailzip},
    { id: '28', col: 'MedicarePartA', val: cleanDate(res.part_a_effective_date) },
    { id: '29', col: 'MedicarePartB', val: cleanDate(res.part_b_effective_date) },
    { id: '30', col: 'AccountHolderName', val: isEFT ? res.eft_actname : '' },
    { id: '31', col: 'RoutingNumber', val: isEFT ? res.eft_routing : '' },
    { id: '32', col: 'BankAccountNumber', val: isEFT ? res.eft_actnum : '' },
    { id: '33', col: 'PremiumDeducted', val: premiumDeducted },
    { id: '34', col: 'AccountType', val: isEFT ? eftActType : '' },
    { id: '35', col: 'OtherCoverage', val: yn(res.othercoverage) }, // required for MA/PD but not PDP
    { id: '36', col: 'OtherCoverageName', val: res.othercoverage ? res.othercoverage_name : '' },
    { id: '37', col: 'OtherCoverageID', val: res.othercoverage ? res.othercoverage_num : '' },
    { id: '38', col: 'LongTerm', val: yesNo(res.ltcf) },
    { id: '39', col: 'LongTermName', val: res.ltcf ? res.ltcf_name : '' },
    { id: '40', col: 'LongTermAddress', val: ltcfAddress },
    { id: '41', col: 'LongTermPhone', val: res.ltcf ? stripPhone(res.ltcf_tel) : '' },
    { id: '42', col: 'AuthorizedRepName', val: poaNameConcat },
    { id: '43', col: 'AuthorizedRepAddress', val: poaAddressConcat },
    { id: '44', col: 'AuthorizedRepCity', val: res.ispoa ? res.poa_addr_city : '' },
    { id: '45', col: 'AuthorizedRepState', val: res.ispoa ? res.poa_addr_state : '' },
    { id: '46', col: 'AuthorizedRepZip', val: res.ispoa ? res.poa_addr_zip : '' },
    { id: '47', col: 'AuthorizedRepPhone', val: res.ispoa ? res.poa_tel : '' },
    { id: '48', col: 'AuthorizedRepRelationship', val: res.ispoa ? res.poa_rel : '' },
    { id: '49', col: 'SpokenLanguage', val: res.spokenlang ? res.spokenlang : '' },
    { id: '50', col: 'ESRD', val: '' }, // Per CMS as of 12/31/2020 ESRD no longer applicable (End-Stage Renal Disease)
    { id: '51', col: 'StateMedicaid', val: yesNoBlank(res.onmedicaid) },
    { id: '52', col: 'WorkStatus', val: yn(res.willwork || res.willworkspouse) },
    { id: '53', col: 'PrimaryCarePhysician', val: res.pcp_name || '' },
    { id: '54', col: 'OtherCoverageGroup', val: res.othercoverage_group },
    { id: '55', col: 'FSR', val: '' }, // Aetna internal use only
    { id: '56', col: 'SubmitTime', val: moment().format('YYYY-MM-DD HH:mm:ss.SSS') },
    { id: '57', col: 'WrittenLanguage', val: res.preflang ? res.preflang : '' },
    { id: '58', col: 'MobilePhoneIndicator', val: ynb(res.home_phone, '') },
    { id: '59', col: 'Race', val: race },
    { id: '60', col: 'Ethnicity', val: ethnicity },
    { id: '61', col: 'LISCopayLevelID', val: '' }, // Aetna internal use only
    { id: '62', col: 'DeemedCopayLevelID', val: '' }, // Aetna internal use only
    { id: '63', col: 'ElectronicEOBStatements', val: ynb(res.okemail, '') }, // Aetna internal use only
    { id: '64', col: 'PremiumWithhold', val: premiumWithold },
    { id: '65', col: 'SEPCMSReason', val: isSEP ? res.sep_other : '' },
    { id: '66', col: 'GeneralAgentTIN', val: '' },
    { id: '67', col: 'BrokerTIN', val: '' },
    { id: '68', col: 'Channel', val: affinityID },
    { id: '69', col: 'AppMethod', val: appMethod }, // opt, skipping
    { id: '70', col: 'ProviderMedicalGroup', val: existsOrBlank(res.pcp_pmg, '') }, // skipping, from spec: California and DSNP plans only
    { id: '71', col: 'OSBCode', val: '' }, // skipping, we don't support OSB selection on enrollment
    { id: '72', col: 'ProviderID', val: res.pcp_num || '' },
    { id: '73', col: 'MedicaidNumber', val:  existsOrBlank(res.medicaidnum, '') },
    { id: '74', col: 'EnrPlanYear', val: planYear },
    { id: '75', col: 'RequestedEffectiveDate', val: effectiveDate },
    { id: '76', col: 'ElectionType', val: electionType },
    { id: '77', col: 'BrokerNPN', val: agentID },
    { id: '78', col: 'GroupName', val: '' }, // from spec: "Group Name the applicant previous belonged to." ???
    { id: '79', col: 'WritingAgentTIN', val: '' }, // we don't store this
    { id: '80', col: 'SEPCode1', val: isSEP ? res.sep_code : '' },
    { id: '81', col: 'SEPEffDate1', val: isSEP ? sepDate : '' },
    { id: '82', col: 'SEPCode2', val: '' }, // I don't know why there are multiple slots for SEP codes?
    { id: '83', col: 'SEPEffDate2', val: '' },
    { id: '84', col: 'SEPCode3', val: '' },
    { id: '85', col: 'SEPEffDate3', val: '' },
    { id: '86', col: 'SupplierID', val: '' }, // Aetna internal use only
    { id: '87', col: 'ImageReferenceNumber', val: '' }, // Paper Application Reference # from keying vendor.
    { id: '88', col: 'DateMarketReceived', val: '' }, // Date Agent rec'd Application
    { id: '89', col: 'HomeOfficeRec Date', val: '' }, // Date Aetna Rec'd Application
    { id: '90', col: 'PrimaryCareID', val: res.primarycare_id || '' },
    { id: '91', col: 'ClientInternalID', val: '' }, // should not be valued
    { id: '92', col: 'ClientInternalCode', val: '' }, // should not be valued
    { id: '93', col: 'MediaType', val: existsOrBlank(res.altwritten, '') },
    { id: '94',col: 'SignatureInd', val: '' }, // Internal Use for paper applications
    { id: '95', col: 'DSNPInd', val: '' }, // Internal Use for paper applications
    // NOTE(santeyio): these fields were disabled during implementation of 2025 enrollment
    // { col: 'CreditCovInd', val: creditableCoverage },
    // { col: 'CreditCovStartDt', val: (creditableCoverage === 'Y') ? cleanDate(res.creditablecov_start) : '' },
    // { col: 'CreditCovEndDt', val: (creditableCoverage === 'Y') ? cleanDate(res.creditablecov_end) : '' },
    // { col: 'CreditCovName', val: (creditableCoverage === 'Y') ? (res.creditablecov_name || '') : '' },

    // ---------------
    // if isCSNP is true, then we need to populate these. Otherwise they should be blank.
    // ----------------
    { id: '96', col: 'CSNPFirstName', val: isCSNP ? res.first_name : '' },
    { id: '97', col: 'CSNPMiddleInitial', val: isCSNP ? res.middle_name : '' },
    { id: '98', col: 'CSNPLastName', val: isCSNP ? res.last_name : '' },
    { id: '99', col: 'CSNPMedicareNumber', val: isCSNP ? res.medicare_id : '' },
    { id: '100', col: 'CSNPBirthdate', val: isCSNP ? moment(res.birthdate).format('MMDDYYYY') : '' },
    { id: '101', col: 'CSNPPhoneNumber', val: isCSNP ? stripPhone(res.home_phone) : '' },
    { id: '102', col: 'CSNPSignature', val: ynb(res.csnp_disclaimer, '') },
    { id: '103', col: 'CSNPAuthrepName', val: isCSNP ? poaNameConcat : '' },
    { id: '104', col: 'CSNPAuthRepAddressLine1', val: isCSNP ? poaAddressConcat : '' },
    { id: '105', col: 'CSNPAuthRepCity', val: (isCSNP && res.ispoa) ? res.poa_addr_city : '' },
    { id: '106', col: 'CSNPAuthRepState', val: (isCSNP && res.ispoa) ? res.poa_addr_state : '' },
    { id: '107', col: 'CSNPAuthRepZip', val: (isCSNP && res.ispoa) ? res.poa_addr_zip : '' },
    { id: '108', col: 'CSNPAuthRelationship', val: (isCSNP && res.ispoa) ? res.poa_rel : '' },
    { id: '109', col: 'CSNPAuthRepTelephone', val: (isCSNP && res.ispoa) ? res.poa_tel : '' },
    { id: '110', col: 'CSNPCondition', val: csnpCondition },
    { id: '111', col: 'CSNPProvider1Name', val: existsOrBlank(res.snp_physician_name) },
    { id: '112', col: 'CSNPProvider1AddressLine1', val: existsOrBlank(res.snp_physician_street1) },
    { id: '113', col: 'CSNPProvider1AddressLine2', val: '' },
    { id: '114', col: 'CSNPProvider1City', val: existsOrBlank(res.snp_physician_city) },
    { id: '115', col: 'CSNPProvider1State', val: existsOrBlank(res.snp_physician_state) },
    { id: '116', col: 'CSNPProvider1Zip', val: existsOrBlank(res.snp_physician_zip) },
    { id: '117', col: 'CSNPProvider1Telephone', val: existsOrBlank(res.snp_physician_tel) },
    { id: '118', col: 'CSNPProvider1Fax ', val: existsOrBlank(res.snp_physician_fax) },
    { id: '119', col: 'CSNPProvider1Email', val: existsOrBlank(res.snp_physician_email) },
    { id: '120', col: 'CSNPProvider2Name', val: '' }, // we only collect 1 csnp provider info
    { id: '121', col: 'CSNPProvider2AddressLine1', val: '' }, // we only collect 1 csnp provider info
    { id: '122', col: 'CSNPProvider2AddressLine2', val: '' }, // we only collect 1 csnp provider info
    { id: '123', col: 'CSNPProvider2City', val: '' }, // we only collect 1 csnp provider info
    { id: '124', col: 'CSNPProvider2State', val: '' }, // we only collect 1 csnp provider info
    { id: '125', col: 'CSNPProvider2Zip', val: '' }, // we only collect 1 csnp provider info
    { id: '126', col: 'CSNPProvider2Telephone', val: '' }, // we only collect 1 csnp provider info
    { id: '127', col: 'CSNPProvider2Fax ', val: '' }, // we only collect 1 csnp provider info
    { id: '128', col: 'CSNPProvider2Email', val: '' }, // we only collect 1 csnp provider info
    { id: '129', col: 'GenderIdentity', val: '' }, // per CMS ruling this isn't populated
    { id: '130', col: 'OtherGenderIdentity', val: '' }, // per CMS ruling this isn't populated
    { id: '131', col: 'SelfIdentity', val: '' }, // per CMS ruling this isn't populated
    { id: '132', col: 'OtherSelfIdentity', val: '' }, // per CMS ruling this isn't populated
    { id: '133', col: 'AssistName ', val: `${agent.firstName} ${agent.lastName}` },
    { id: '134', col: 'AssistRelationshipToEnrollee', val: res.agent_relationship },
    { id: '135', col: 'AssistNPN/Broker ', val: agentID },
    { id: '136', col: 'FutureUse136', val: '' },
    { id: '137', col: 'FutureUse137', val: '' },
    { id: '138', col: 'FutureUse138', val: '' },
    { id: '139', col: 'FutureUse139', val: '' },
    { id: '140', col: 'FutureUse140', val: '' },
    { id: '141', col: 'FutureUse141', val: '' },
    { id: '142', col: 'FutureUse142', val: '' },
    { id: '143', col: 'FutureUse143 ', val: '' },
    { id: '144', col: 'FutureUse144 ', val: '' },
    { id: '145', col: 'FutureUse145 ', val: '' },
    { id: '146', col: 'FutureUse146', val: '' },
    { id: '147', col: 'FutureUse147 ', val: '' },
    { id: '148', col: 'FutureUse148', val: '' },
    { id: '149', col: 'FutureUse149 ', val: '' },
    { id: '150', col: 'FutureUse150', val: '' },
  ];

  return { formattedData, agentID };
};
